<template>
    <video :ref="videoPlayerRef" muted="muted" style="width: 100%;height: 100%;"></video>
</template>

<script>
import mpegts from 'mpegts.js';
export default {
    props: {
        videoUrl: {
            type: String,
            default() {
                return ''
            }
        },
        isLive: {
            type: Boolean,
            default() {
                return false;
            }
        },
        videoPlayerRef: {
            type: String,
            default() {
                return 'videoPlayer'
            }
        }
    },
    data() {
        return {
            player: null,
        }
    },
    watch: {
        videoUrl(val) {
            if (val) {
                this.createPlayer();
            }
        }
    },
    mounted() {
        this.createPlayer();
    },
    methods: {
        createPlayer() {
            if (mpegts.isSupported()) {
                if (this.player) {
                    this.videoDestory();
                }
                this.player = mpegts.createPlayer(
                    {
                        type: "flv",
                        url: this.videoUrl,
                        isLive: this.isLive,
                        isAutoPlay: true,
                        isContinue: true, //是否循环播放
                        lazyLoad: true,//如果有足够的数据进行播放，则终止http连接
                        hasAudio: false,//声音关闭，如果传来的视频流没有声音，就一定要设置这个参数，否则会报错
                    },
                    {
                        enableWorker: true,//是否启用分离线程
                        enableStashBuffer: false,//是否关闭IO隐藏缓冲区
                        stashInitialSize: 128,//IO存储缓冲区初始大小，默认为384kb
                    }
                );

                this.$nextTick(() => {
                    this.player.attachMediaElement(this.$refs[this.videoPlayerRef]);
                    this.player.load();
                    setTimeout(() => {
                        this.player
                            .play()
                            .then(() => {
                                console.log("play...");
                            })
                            .catch((err) => {
                                console.log("err", err);
                            });
                    });
                });
            }
        },
        videoDestory() {
            if (this.player) {
                try {
                    this.player.pause();
                    this.player.unload();
                    this.player.detachMediaElement();
                    this.player.destroy();
                    this.player = null;
                } catch (e) {

                }
            }
        },
    }
}
</script>